import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { trackChatMacrosCopied } from '../../../analytics/mlEventAnalytics';
import MacroMetadata from 'components/common/AlertOrMacroMetadata/AlertOrMacroMetadata';
import {
  ButtonContainer,
  RecommendationButton,
  MacroMetadataWrapper,
  RecommendationContainer,
  LeftSideContainer,
  RightSideContainer,
  NotHelpfulButton,
  UseThisButton,
} from './ChatUIMacrosTab.styles';
import ChatUIEmptyTab from '../ChatUIEmptyTab/ChatUIEmptyTab';
import { chatUITabs } from 'constants/chatUI';

const propTypes = {
  recommendedMacros: PropTypes.array.isRequired,
  selectedMacro: PropTypes.object.isRequired,
  selectMacro: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onMacroPersist: PropTypes.func.isRequired,
};

const ChatUIMacrosTab = ({ recommendedMacros, selectedMacro, selectMacro, onClose, onMacroPersist }) => {
  const isSelectedMacro = (macroArticleId) => {
    return !!selectedMacro && selectedMacro.macro_article_id === macroArticleId;
  };
  const renderChatMacroTitles = () => {
    return (
      <ButtonContainer>
        {recommendedMacros.map((macro) => {
          return (
            <RecommendationButton
              key={macro.macro_article_id}
              selected={isSelectedMacro(macro.macro_article_id)}
              onClick={() => selectMacro(macro.macro_article_id)}
            >
              {macro.title}
            </RecommendationButton>
          );
        })}
      </ButtonContainer>
    );
  };

  return (
    <>
      {isEmpty(recommendedMacros) ? (
        <ChatUIEmptyTab title={chatUITabs.macros.tabName} />
      ) : (
        <>
          {renderChatMacroTitles()}
          <RecommendationContainer>
            <MacroMetadataWrapper>
              <MacroMetadata resource={selectedMacro ? selectedMacro : {}} theme="dark" />
            </MacroMetadataWrapper>
            <LeftSideContainer>
              <textarea
                value={get(selectedMacro, 'text', '')}
                resize="none"
                readOnly
                onCopy={() => trackChatMacrosCopied(selectedMacro, 'FREE_COPY')}
              />
            </LeftSideContainer>
            <RightSideContainer>
              <NotHelpfulButton onClick={() => onClose('NOT_HELPFUL_BUTTON')}>Not helpful</NotHelpfulButton>
              <UseThisButton onClick={onMacroPersist}>Use this</UseThisButton>
            </RightSideContainer>
          </RecommendationContainer>
        </>
      )}
    </>
  );
};

ChatUIMacrosTab.propTypes = propTypes;

export default ChatUIMacrosTab;
